import styled from 'styled-components';

export const StyledSocialContainer = styled.div`
  display: flex;
  gap: 1.3rem;
`;

export const StyledWrapper = styled.div``;

export const StyledSocialLink = styled.a`
  align-items: center;
  border-radius: 2rem;
  color: ${({ theme }) => theme.colors.white};
  display: flex;
  width: 2.8rem;
  height: 2.8rem;
  justify-content: center;
  text-decoration: none;
  background-color: #727c92;

  &:hover {
    filter: brightness(1.2);
  }

  svg {
    width: 1.2rem;
    height: 1.3rem;
    margin: 0;

    path {
      fill: ${({ theme }) => theme.colors.white};
    }
  }

  &[data-social='twitter'] {
    &:hover {
      background-color: ${({ theme }) => theme.colors.twitter.main};
      color: ${({ theme }) => theme.colors.white};
    }
  }

  &[data-social='facebook'] {
    &:hover {
      background-color: ${({ theme }) => theme.colors.facebook.main};
      color: ${({ theme }) => theme.colors.white};
    }
  }

  &[data-social='linkedin'] {
    &:hover {
      background-color: ${({ theme }) => theme.colors.linkedIn.main};
      color: ${({ theme }) => theme.colors.white};
    }
  }
`;
